import {createSlice} from '@reduxjs/toolkit';

import Api from "../../api/Api";

type State = {
	currentDashboardId: string | null,
	data: Object,
	isLoading: boolean,
	error: Object | null,
	widgets: Array<any>
}

// Slice
const slice = createSlice({
	name: 'dashboard',
	initialState: {
		currentDashboardId: null,
		data: {},
		isLoading: false,
		widgets: [],
		error: null,
	},
	reducers: {
		fetchDashboardStart: (state: State, action) => {
			state.isLoading = true;
			state.currentDashboardId = action.payload;
		},
		fetchDashboardSuccess: (state: State, action) => {
			state.data = action.payload;
			state.widgets = action.payload.grid_config;
			state.isLoading = false;
		},
		fetchDashboardFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchDashboardStart,
	fetchDashboardSuccess,
	fetchDashboardFailed
} = slice.actions;

let currentDashboardRequest = null as any;

export const getDashboard = (id: string, versionTest? : boolean) => async (dispatch: Function) => {
	try {
		if (currentDashboardRequest) {
			currentDashboardRequest.abort();
		  }
		dispatch(fetchDashboardStart(id));

		const controller = new AbortController(); // Create a new AbortController
		// @ts-ignore
		currentDashboardRequest = controller;
		const api = new Api();
		const result = await api.getDashboard(id,versionTest);
		if (result !== "No internet connection") {
			dispatch(fetchDashboardSuccess(result));
		}
	} catch (err: any) {
		dispatch(fetchDashboardFailed(err));
	}
}
